module.exports = __webpack_public_path__ + "static/17_01_abacus_research_und_lehmannpartner_informatik_spannen_zusammen-0cc3eb559cad5b02edbc2a7e5f46a779.pdf";